import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Injector,
  ViewChild,
  TemplateRef
} from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Staff } from './contact';
import { Practice } from '../practices/practice';
import { ContactService } from '../../../services/contact.service';
import { PhoneService } from '../../../voice-call/phone.service';
import { UserComponent } from '../../users/user/user.component';
import { AlertService } from '../../../_alert';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit, OnDestroy {
  public staffs: Staff[] = [];

  @Input() practice: Practice;
  @Input() practice_permissions: string;

  public selected_index: number | null = null;
  public show_contact = false;
  public pencil = false;
  public dom_count: number;
  public edit_contact = false;
  public new_staff: Staff = new Staff();

  @ViewChild('userModalTemplate')
  userModalTemplate: TemplateRef<any>;

  public userModalRef: BsModalRef | null = null;
  public customInjectorForPopup: Injector;
  public showUserModel = false;
  public userComponent = UserComponent;

  public deleteModalRef: BsModalRef | null = null;
  public staffToDelete: Staff | null = null;
  public deletingStaff = false;

  constructor(
    private contactService: ContactService,
    public phoneService: PhoneService,
    public injector: Injector,
    public alertService: AlertService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.getContacts();
  }

  ngOnDestroy(): void {
    this.closeDeleteModal();
    this.closeUserModal();
  }

  show_pencil(index: number): void {
    this.dom_count = index;
    this.pencil = true;
  }

  hide_pencil(): void {
    this.pencil = false;
  }

  toggle_contact(): void {
    if (this.selected_index === null && this.show_contact) {
      this.new_staff = new Staff();
      this.hide_form();
    } else {
      this.selected_index = null;
      this.show_form();
    }
  }

  sync_staff(event): void {
    this.staffs.push(event.load_from_jason(event));
    this.practice.staffs = this.staffs;
    this.hide_form();
    this.new_staff = new Staff();
  }

  select_contact(index: number): void {
    this.selected_index = index;
    this.show_form();
  }

  hide_form(): void {
    this.show_contact = false;
  }

  show_form(): void {
    this.show_contact = true;
  }

  reset_show_contact(event): void {
    this.hide_form();
    this.new_staff = new Staff();
  }

  editContact(): void {
    this.edit_contact = !this.edit_contact;
  }

  openDeleteModal(
    template: TemplateRef<any>,
    staff: Staff
  ): void {
    if (this.deletingStaff) {
      return;
    }

    this.closeDeleteModal();
    this.staffToDelete = staff;

    this.deleteModalRef = this.modalService.show(template, {
      class: 'modal-md',
      backdrop: false
    });
  }

  closeDeleteModal(): void {
    if (this.deleteModalRef) {
      this.deleteModalRef.hide();
      this.deleteModalRef = null;
    }

    this.staffToDelete = null;
  }

  confirmDeleteStaff(): void {
    if (!this.staffToDelete || this.deletingStaff) {
      return;
    }

    this.delete(this.staffToDelete);
  }

  delete(staff: Staff): void {
    if (this.deletingStaff) {
      return;
    }

    this.deletingStaff = true;

    this.contactService.delete(staff.id)
      .then(response => {
        this.deletingStaff = false;

        if (response.status) {
          const index = this.staffs.indexOf(staff);

          if (index !== -1) {
            this.staffs.splice(index, 1);

            // Keep the selected edit row aligned after deletion.
            if (this.selected_index === index) {
              this.selected_index = null;
              this.hide_form();
              this.new_staff = new Staff();
            } else if (
              this.selected_index !== null &&
              this.selected_index > index
            ) {
              this.selected_index -= 1;
            }
          }

          this.practice.staffs = this.staffs;
          this.closeDeleteModal();

          this.alertService.success(
            'Deleted successfully',
            this.alertService.options
          );
        }
      })
      .catch(error => {
        this.deletingStaff = false;
        console.error('Failed to delete staff:', error);
      });
  }

  createUpdateUser(staff: Staff): void {
    this.closeUserModal();

    const user = staff.user;

    const profile_type = user.profileable_type
      ? user.profileable_type
      : (staff.practice_id ? 'practice' : '');

    this.customInjectorForPopup = Injector.create(
      [
        { provide: 'id', useValue: user.id },
        { provide: 'isContactPage', useValue: true },
        { provide: 'profile_type', useValue: profile_type },
        { provide: 'profileable_id', useValue: user.profileable_id },
        { provide: 'staff', useValue: staff },
        {
          provide: 'onUserSavedHandler',
          useValue: () => this.onUserSaved()
        }
      ],
      this.injector
    );

    this.showUserModel = true;

    this.userModalRef = this.modalService.show(
      this.userModalTemplate,
      {
        class: 'modal-lg staff-user-modal',
        backdrop: false
      }
    );
  }

  closeUserModal(): void {
    if (this.userModalRef) {
      this.userModalRef.hide();
      this.userModalRef = null;
    }

    this.showUserModel = false;
  }

  onUserSaved(): void {
    this.closeUserModal();
    this.staffs = [];
    this.getContacts();
  }

  getContacts(): void {
    this.contactService.getContacts(this.practice.id)
      .then(contacts => {
        for (const contact of contacts) {
          this.staffs.push(
            new Staff().load_from_jason(contact)
          );
        }
      });
  }


}
